import { render, staticRenderFns } from "./ModalTanggalPenagihan.vue?vue&type=template&id=0b85aad4&scoped=true"
import script from "./ModalTanggalPenagihan.vue?vue&type=script&lang=js"
export * from "./ModalTanggalPenagihan.vue?vue&type=script&lang=js"
import style0 from "./ModalTanggalPenagihan.vue?vue&type=style&index=0&id=0b85aad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85aad4",
  null
  
)

export default component.exports